import { useQuery } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useVisualization = (visualizationId) => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()

  const getVisualization = async (visualizationId) => {
    const url = encodeURI(`${env.apiUrl}/visualizations/${visualizationId}`)
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['visualization', visualizationId],
    queryFn: () => getVisualization(visualizationId),
    enabled: !!visualizationId,
    gcTime: 0,
    refetchOnWindowFocus: false
  })

  if (query.isLoading) {
    progressStart()
  } else if (query.isSuccess) {
    progressEnd()
  } else if (query.isError) {
    handleError(query.error, 'Error getting visualization')
    progressEnd()
  }

  return {
    visualization: query.data
  }
}

export { useVisualization }
